import React from 'react';
import { Save as SaveIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import StandardButton from './StandardButton';
import type { ButtonProps } from '@mui/material';

type SaveButtonProps = Omit<ButtonProps, 'variant' | 'startIcon'> & {
  loading?: boolean;
  showIcon?: boolean;
};

const SaveButton: React.FC<SaveButtonProps> = ({
  loading = false,
  showIcon = false,
  children,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <StandardButton
      variant="primary"
      loading={loading}
      startIcon={showIcon && !loading ? <SaveIcon /> : undefined}
      aria-label="Save changes"
      {...props}
    >
      {children ?? t('common:buttons.save')}
    </StandardButton>
  );
};

export default SaveButton;
